import { Component, OnInit } from '@angular/core';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { ContactsService } from 'src/app/services/client-services/contacts.service';
import { CompaniesService } from 'src/app/services/client-services/companies.service';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-client-suggestions',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  /** */
  loading: boolean = false;

  /** */
  context_name: string;
  context_item: number;

  context_item_name: any;

  context_title: string;

  /** */
  suggested_companies: Array<any> = [];
  suggested_contacts: Array<any> = [];

  /** */
  contact_companies: any = {};
  company_contacts: any = {};

  /** */
  constructor(
    private email_service: EmailService,
    private company_service: CompaniesService,
    private contact_service: ContactsService,
    private toast: ToastrService
  ) { }

  ngOnInit() {
    this.email_service.email_context.subscribe(context => {
      if (Object.keys(context).length) {
        this.context_name = context.name;
        let domain_name;
        switch (context.name) {
          case 'company':
            const { domainName, website, name } = context.company;
            this.context_item_name = name;
            this.context_item = context.company.clientId;
            this.context_title = 'Contacts';

            if (website) domain_name = this.extract_domain_name_from_web(website);
            if (domainName) domain_name = this.extract_domain_name_from_web(domainName);

            this.fetch_contact_suggestions(domain_name);
            this.fetch_company_contacts(this.context_item);
            break;
          case 'contact':
            const { email, otherEmail, firstName, surName } = context.contact;
            this.context_item_name = `${surName || ''} ${firstName || ''}`;
            this.context_item = context.contact.clientId;
            this.context_title = 'Companies';

            if (otherEmail) domain_name = this.extract_domain_name_from_email(otherEmail);
            if (email) domain_name = this.extract_domain_name_from_email(email);

            this.fetch_company_suggestions(domain_name);
            this.fetch_contact_companies(this.context_item);
            break;
          default:
        }
      }
    });
  }

  add_company_to_contact(data: any) {
    this.loading = true;
    this.contact_service.addCompanyToContact({ ...data }).subscribe((response: any) => {
      this.loading = false;
      if (response.success) {
        this.toast.success('Company added successfully');
        this.contact_companies[response.payload.companyId] = true;
      } else this.toast.error('Unable to add company');
    }, e => {
      this.loading = false;
      this.toast.error('Unable to add company');
    })
  }

  add_contact_to_company(data: any) {
    this.loading = true;
    this.company_service.addContactToCompany({ ...data }).subscribe((response: any) => {
      this.loading = false;
      if (response.success) {
        this.toast.success('Contact added sucessfully');
        this.company_contacts[response.payload.contactId] = true;
      }
    }, e => {
      this.loading = false;
      this.toast.error('Unable to add contact');
    })
  }

  extract_domain_name_from_web(domain_name: string) {
    const raw_domain_name = domain_name.toLocaleLowerCase();

    let sample_domain = domain_name.toLocaleLowerCase();
    if (raw_domain_name.includes('http')) {
      sample_domain = raw_domain_name.split('/')[2]
    }

    let extracted_domain_name = sample_domain;
    if (sample_domain.includes('www.')) {
      extracted_domain_name = sample_domain.replace(/(www.)/i, '');
    }

    return extracted_domain_name;
  }

  extract_domain_name_from_email(email_address: string) {
    const domain = (email_address.toLocaleLowerCase()).split('@')[1];
    return domain;
  }

  fetch_company_contacts(id: any) {
    this.company_service.getContactForCompany(id).subscribe((response: any) => {
      if (response.success) {
        this.company_contacts = response.payload.reduce((accumulator, contact) => ({
          ...accumulator,
          [contact.clientId]: true,
        }), {});
      }
    });
  }

  fetch_contact_companies(id: any) {
    this.contact_service.getCompanyForContact(id).subscribe((response: any) => {
      if (response.success) {
        const { payload } = response;
        this.contact_companies = payload.reduce((accumulator, company) => ({
          ...accumulator,
          [company.clientId]: true,
        }), {});
      }
    });
  }

  fetch_company_suggestions(value: string) {
    this.company_service.getWildcardCompanies(value).subscribe((response: any) => {
      if (response.success) {
        this.suggested_companies = [...response.payload];
      }
    }, e => e);
  }

  fetch_contact_suggestions(value: string) {
    this.contact_service.getContactWildcard(value).subscribe((response: any) => {
      if (response.success) {
        this.suggested_contacts = [...response.payload];
      }
    }, e => e);
  }

  link_clients(clientId: string, type: string) {
    //
    if (type.toLocaleLowerCase() == 'contact') {
      this.add_contact_to_company({ contactId: clientId, companyId: this.context_item });
    }

    if (type.toLocaleLowerCase() == 'company') {
      this.add_company_to_contact({ companyId: clientId, contactId: this.context_item });
    }
  }
}
